import PendingApprovalAdviserProfilesApi from '../../../core/api/PendingApprovalAdviserProfilesApi'
import {toast} from 'react-toastify'
import { events as editorEvents } from '../AdviserProfileEditorContainer/adviserProfileEditorContainerActions'
const pendingApprovalAdviserProfilesApi = new PendingApprovalAdviserProfilesApi()

export const events = {
  submit: {
    submitting: 'SUBMITTING_PROFILE_FOR_APPROVAL',
    submitted: 'SUBMITTED_PROFILE_FOR_APPROVAL',
    submit: 'SUBMIT_PROFILE_FOR_APPROVAL',
    failed: 'SUBMIT_PROFILE_FOR_APPROVAL_FAILED'
  }
}

export const actions = {
  submit: {
    submitForApproval: (adviserId) => {
      const request = pendingApprovalAdviserProfilesApi.submitForApproval(adviserId)
      return (dispatch) => {
        dispatch({ type: events.submit.submitting })
        request.then(function (response) {
          toast.success('Submitted')
          dispatch(pendingApprovalAdviserProfilesApi.handleResponse(events.submit.submitted, response))
          // The profile now has a pending submission - flag it so the editor's button
          // swaps from "Edit" to "Pending approval" immediately (no page reload needed).
          // Safe to set optimistically: this .then only runs on a successful submit.
          dispatch({ type: editorEvents.fetch.fetchedPendingProfile, payload: { adviserId } })
        }).catch(function () {
          toast.error('Submission failed - your profile may be missing mandatory fields')
          dispatch({ type: events.submit.failed })
        })
      }
    }

  }
}
